import { render, staticRenderFns } from "./DHLTracking.vue?vue&type=template&id=297eb5eb&scoped=true"
import script from "./DHLTracking.vue?vue&type=script&lang=js"
export * from "./DHLTracking.vue?vue&type=script&lang=js"
import style0 from "./DHLTracking.vue?vue&type=style&index=0&id=297eb5eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297eb5eb",
  null
  
)

export default component.exports